/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { EAuditProject, EAuditTemplate } from '@/common/enum/audit';
import {
  IResAuditTask,
  IReqSubmitAuditParam,
  IResToAuditTaskBrief,
  IResAuditProject,
  IResAuditTaskBrief,
  IResCityAuditTaskNum,
  IAuditAggregation,
} from '@/common/interface/audit';
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';
// import { BASE_AUDIT_URL } from '@/common/constant';
import StorageService from './storage.service';
import AuditTask from '@/models/audit.model';
import SPUService from './spu.service';
import { base64url_encode } from '@/common/utils/base64';
import UserService from '@/services/user.service';
import { getCurrentTimeSecond, replacePlaceholders } from '@/common/utils';


@injectable()
export default class AuditService {
  @inject(HttpClient)
  protected http!: HttpClient;

  @inject(StorageService)
  protected storage!: StorageService;


  @inject(UserService)
  protected user!: UserService;

  @inject(SPUService)
  protected spuService!: SPUService;

  /** 获取审核聚合任务 */
  async auditAggregation(
    projectId: string,
    polymerizeId: string,
    loadingEl?: Element | Vue,
  ): Promise<{
    auditData: any;
    auditTaskAggregation: IAuditAggregation[];
  }> {
    // const user = this.storage.get('user');
    // const userId = user ? user.id : null;
    const keyValue = await this.http.get('query/image_add_watermark_value/keyValue') as any;
    const phone = this.user.currentUser()?.name || this.user.currentUser()?.phone;
    const currentTime = { username: base64url_encode(`${phone} ${getCurrentTimeSecond()}`) };
    const keyUrl = replacePlaceholders(keyValue, currentTime);

    function removeUrlParams(url: string, isAddWatermark?: boolean): string {
      const urlObj = new URL(url);
      urlObj.searchParams.delete('Expires');
      urlObj.searchParams.delete('OSSAccessKeyId');
      if (isAddWatermark) {
        urlObj.searchParams.append('x-oss-process', keyUrl);
      }
      return urlObj.href;
    }
    try {
      const result: {
        auditData: any;
        auditTaskAggregation: IAuditAggregation[];
      } = {
        auditTaskAggregation: [],
        auditData: null,
      };
      const params = {
        projectId,
        polymerizeId,
      };
      const res = (await this.http.get(
        'audit_service/user/project/task',
        { params },
      )) as IResAuditTask;

      if (res) {
        const { auditData, polymerizeTaskUpdateData, template, projectID, templateKey } =
          res;

        for (const [taskId, v] of Object.entries(polymerizeTaskUpdateData)) {
          const { nodeId, data } = v;
          // console.log('auditData======', data);
          /** @note 非入驻门店： 聚合任务data为null, 表示是新创建的审核内容。因接口的实现会将新创建的待审核data直接写入到 auditData审核原始数据，故前端需要把auditData[taskId]填充为待审核的data */
          const data_: { [key: string]: any } = data || auditData[taskId];
          // data_.shopLicenseValidDateType = data_.shopLicenseValidDateType;
          const task: {
            nodeId: string;
            taskId: string;
            auditUpdateData: any;
            tplType: EAuditTemplate;
            tplTypeKey: string;
            shouldShowOriginalData: boolean;
          } = {
            nodeId,
            auditUpdateData: AuditTask.from(data_, projectID),
            tplType: template,
            taskId,
            shouldShowOriginalData: projectID !== 3 && data != null,
            tplTypeKey: templateKey,
          };

          if (projectID === EAuditProject.店铺商品审核) {
            // eslint-disable-next-line no-await-in-loop
            const indicativePrice = await this.spuService.indicativePrice({
              categoryId: task.auditUpdateData?.category.id,
              shopId: Number(task.auditUpdateData?.shopId),
              loadingEl,
            });
            if (task.auditUpdateData && indicativePrice) {
              task.auditUpdateData.indicativePrice = indicativePrice || '';
            }
          }

          const _uauditData = auditData[taskId];
          const _uauditUpdateData = task.auditUpdateData;
          // console.log('task======', _uauditData, _uauditUpdateData);
          if (_uauditData) {
            const bossIdImage: any = [];
            const shopImages: any = [];
            const shoplicense: any = [];
            const otherQualifications: any = [];
            const roadTransportBusinessLicense: any = [];
            const maintenanceOperationalVehicles: any = [];
            _uauditData.bossIdImage?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              bossIdImage.push(url);
            });
            _uauditData.shopImages?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, false),
                order: item.order,
              };
              shopImages.push(url);
            });
            _uauditData.shoplicense?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              shoplicense.push(url);
            });

            _uauditData.otherQualifications?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              otherQualifications.push(url);
            });


            _uauditData.roadTransportBusinessLicense?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              roadTransportBusinessLicense.push(url);
            });
            _uauditData.maintenanceOperationalVehicles?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              maintenanceOperationalVehicles.push(url);
            });
            if (otherQualifications.length > 0) {
              auditData[taskId].otherQualifications = otherQualifications;
            }
            if (roadTransportBusinessLicense.length > 0) {
              auditData[taskId].roadTransportBusinessLicense = roadTransportBusinessLicense;
            }
            if (maintenanceOperationalVehicles.length > 0) {
              auditData[taskId].maintenanceOperationalVehicles = maintenanceOperationalVehicles;
            }
            if (shoplicense.length > 0) {
              auditData[taskId].shoplicense = shoplicense;
            }
            if (shopImages.length > 0) {
              auditData[taskId].shopImages = shopImages;
            }
            if (bossIdImage.length > 0) {
              auditData[taskId].bossIdImage = bossIdImage;
            }
          }
          if (_uauditUpdateData) {
            const bossIdImage: any = [];
            const shopImages: any = [];
            const shoplicense: any = [];
            _uauditUpdateData.bossIdImage?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              bossIdImage.push(url);
            });
            _uauditUpdateData.shopImages?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, false),
                order: item.order,
              };
              shopImages.push(url);
            });
            _uauditUpdateData.shoplicense?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              shoplicense.push(url);
            });
            if (shoplicense.length > 0) {
              task.auditUpdateData.shoplicense = shoplicense;
            }
            if (shopImages.length > 0) {
              task.auditUpdateData.shopImages = shopImages;
            }
            if (bossIdImage.length > 0) {
              task.auditUpdateData.bossIdImage = bossIdImage;
            }

            const otherQualifications: any = [];
            const roadTransportBusinessLicense: any = [];
            const maintenanceOperationalVehicles: any = [];
            _uauditData.otherQualifications?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              otherQualifications.push(url);
            });
            _uauditData.roadTransportBusinessLicense?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              roadTransportBusinessLicense.push(url);
            });
            _uauditData.maintenanceOperationalVehicles?.forEach((item: any) => {
              const url = {
                id: item.id,
                url: removeUrlParams(item.url, true),
                order: item.order,
              };
              maintenanceOperationalVehicles.push(url);
            });
            if (otherQualifications.length > 0) {
              task.auditUpdateData.otherQualifications = otherQualifications;
            }
            if (roadTransportBusinessLicense.length > 0) {
              task.auditUpdateData.roadTransportBusinessLicense = roadTransportBusinessLicense;
            }
            if (maintenanceOperationalVehicles.length > 0) {
              task.auditUpdateData.maintenanceOperationalVehicles = maintenanceOperationalVehicles;
            }
          }
          result.auditTaskAggregation.push(task);
        }
        result.auditData = auditData;
      }

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /** 审核类型 done */
  async auditProjects(params?: any) {
    return (await this.http.get(
      'audit_service/project', { params },
    )) as IResAuditProject[];
  }

  /** 审核列表 done */
  async list(
    params: {
      pageSize?: number;
      page: number;
      name?: string;
      projectId?: number;
      auditStatus?: number;
      createStartTime?: string;
      createEndTime?: string;
      auditStartTime?: string;
      auditEndTime?: string;
    },
    loadingEl: Element | Vue,
  ) {
    try {
      const res = (await this.http.get('audit_service/tasks', {
        params,
        data: { loadingEl },
      })) as {
        list: IResAuditTaskBrief[];
        lastPage: number;
        page: number;
        pageSize: string;
        total: number;
      };
      return res;
    } catch (error) {
      return null;
    }
  }

  /** 审核任务详情 done  isModified后续移除  */
  async task(taskId: number, loadingEl: Element | Vue) {
    const keyValue = await this.http.get('query/image_add_watermark_value/keyValue') as any;
    const phone = this.user.currentUser()?.name || this.user.currentUser()?.phone;
    const currentTime = { username: base64url_encode(`${phone} ${getCurrentTimeSecond()}`) };
    const keyUrl = replacePlaceholders(keyValue, currentTime);
    function removeUrlParams(url: string, isBossIdImage: boolean): string {
      const urlObj = new URL(url);
      urlObj.searchParams.delete('Expires');
      urlObj.searchParams.delete('OSSAccessKeyId');
      if (isBossIdImage) {
        urlObj.searchParams.append('x-oss-process', keyUrl);
      }
      return urlObj.href;
    }
    try {
      const params = {
        taskId,
      };
      const res = (await this.http.get('/audit_service/task/info', {
        params,
      })) as {
        projectID: number;
        taskId: number;
        auditNode: Array<{
          auditStatus: number;
          auditNodeId: number;
          auditUserName: string;
          auditTime: string;
        }>;
        template: EAuditTemplate;
        auditData: any;
        auditUpdateData: any;
        createTime: string;
        createUserName: string;
      };

      /** @note 非入驻门店： auditUpdateData 为null, 表示是新创建的审核内容，故前端需要把auditData填充到待审核的 auditUpdateData； */
      if (res) {
        const {
          auditNode,
          template,
          auditData,
          auditUpdateData,
          createTime,
          createUserName,
          projectID,
        } = res;

        const result: {
          taskId: number;
          auditNode: Array<{
            auditStatus: number;
            auditNodeId: number;
            auditUserName: string;
            auditTime: string;
          }>;
          auditData: any;
          tplType: EAuditTemplate;
          auditUpdateData: any;
          createTime: string;
          creator: string;
          shouldShowOriginalData: boolean;
        } = {
          taskId,
          auditNode,
          auditData,
          auditUpdateData: AuditTask.from(
            auditUpdateData != null ? auditUpdateData : auditData,
            projectID,
          ),

          tplType: template,
          createTime,
          creator: createUserName || '未知用户',
          shouldShowOriginalData: projectID !== 3 && auditUpdateData != null,
        };

        if (projectID === EAuditProject.店铺商品审核) {
          const indicativePrice = await this.spuService.indicativePrice({
            categoryId: auditUpdateData
              ? auditUpdateData.category.id
              : auditData.category.id,
            shopId: auditUpdateData
              ? Number(auditUpdateData.shopId)
              : Number(auditData.shopId),
            loadingEl,
          });
          result.auditUpdateData.indicativePrice = indicativePrice || '';
        }
        const _uauditData = result.auditData;
        const _uauditUpdateData = result.auditUpdateData;
        // console.log('task======', auditData, auditUpdateData);
        if (_uauditData) {
          const bossIdImage: any = [];
          const shopImages: any = [];
          const shoplicense: any = [];
          _uauditData.bossIdImage?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            bossIdImage.push(url);
          });
          _uauditData.shopImages?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, false),
              order: item.order,
            };
            shopImages.push(url);
          });
          _uauditData.shoplicense?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            shoplicense.push(url);
          });
          if (shoplicense.length > 0) {
            result.auditData.shoplicense = shoplicense;
          }
          if (shopImages.length > 0) {
            result.auditData.shopImages = shopImages;
          }
          if (bossIdImage.length > 0) {
            result.auditData.bossIdImage = bossIdImage;
          }
          const otherQualifications: any = [];
          const roadTransportBusinessLicense: any = [];
          const maintenanceOperationalVehicles: any = [];
          _uauditData.otherQualifications?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            otherQualifications.push(url);
          });
          _uauditData.roadTransportBusinessLicense?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            roadTransportBusinessLicense.push(url);
          });
          _uauditData.maintenanceOperationalVehicles?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            maintenanceOperationalVehicles.push(url);
          });
          if (otherQualifications.length > 0) {
            result.auditUpdateData.otherQualifications = otherQualifications;
          }
          if (roadTransportBusinessLicense.length > 0) {
            result.auditUpdateData.roadTransportBusinessLicense = roadTransportBusinessLicense;
          }
          if (maintenanceOperationalVehicles.length > 0) {
            result.auditUpdateData.maintenanceOperationalVehicles = maintenanceOperationalVehicles;
          }
        }
        if (_uauditUpdateData) {
          const bossIdImage: any = [];
          const shopImages: any = [];
          const shoplicense: any = [];
          _uauditUpdateData.bossIdImage?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            bossIdImage.push(url);
          });
          _uauditUpdateData.shopImages?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, false),
              order: item.order,
            };
            shopImages.push(url);
          });
          _uauditUpdateData.shoplicense?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            shoplicense.push(url);
          });
          if (shoplicense.length > 0) {
            result.auditUpdateData.shoplicense = shoplicense;
          }
          if (shopImages.length > 0) {
            result.auditUpdateData.shopImages = shopImages;
          }
          if (bossIdImage.length > 0) {
            result.auditUpdateData.bossIdImage = bossIdImage;
          }
          const otherQualifications: any = [];
          const roadTransportBusinessLicense: any = [];
          const maintenanceOperationalVehicles: any = [];
          _uauditData.otherQualifications?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            otherQualifications.push(url);
          });
          _uauditData.roadTransportBusinessLicense?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            roadTransportBusinessLicense.push(url);
          });
          _uauditData.maintenanceOperationalVehicles?.forEach((item: any) => {
            const url = {
              id: item.id,
              url: removeUrlParams(item.url, true),
              order: item.order,
            };
            maintenanceOperationalVehicles.push(url);
          });
          if (otherQualifications.length > 0) {
            result.auditUpdateData.otherQualifications = otherQualifications;
          }
          if (roadTransportBusinessLicense.length > 0) {
            result.auditUpdateData.roadTransportBusinessLicense = roadTransportBusinessLicense;
          }
          if (maintenanceOperationalVehicles.length > 0) {
            result.auditUpdateData.maintenanceOperationalVehicles = maintenanceOperationalVehicles;
          }
        }
        return result;
      }
    } catch (error) {
      return null;
    }
  }

  /** 待审核列表 done */
  async toAuditList(
    params: {
      pageSize?: number;
      page: number;
      name?: string;
      startTime?: string;
      endTime?: string;
    },
    loadingEl: Element | Vue,
  ) {
    try {
      // const user = this.storage.get('user');
      // const userId = user ? user.id : null;

      const res = (await this.http.get(
        'audit_service/wait-tasks',
        {
          params,
          data: {
            loadingEl,
          },
        },
      )) as {
        list: IResToAuditTaskBrief[];
        lastPage: number;
        page: number;
        pageSize: string;
        total: number;
      };
      return res;
    } catch (error) {
      return null;
    }
  }

  /** 城市待审核任务数 done */
  async cityAuditTaskNums() {
    try {
      // const userStorage = localStorage.getItem('user');
      // const userId = userStorage ? JSON.parse(userStorage).id : null;
      const res = (await this.http.get(
        'audit_service/user/wait-tasks/city',
      )) as IResCityAuditTaskNum[];
      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 提交审核: 包含通过、拒绝 done  */
  async submit(
    param: IReqSubmitAuditParam,
    loadingEl: Element | Vue,
  ): Promise<string> {
    try {
      // const userStorage = localStorage.getItem('user');
      // const userId = userStorage ? JSON.parse(userStorage).id : null;
      const { auditStatus, auditUpdateData, auditData, auditReason, nodeId } =
        param;
      const submitParam: Omit<IReqSubmitAuditParam, 'nodeId'> & {
        nodeId: string | number;
        loadingEl: Element | Vue;
      } = {
        auditStatus,
        auditData,
        nodeId,
        loadingEl,
      };

      if (typeof auditUpdateData !== 'undefined') {
        // 审核不通过，不会传递此参数
        submitParam.auditUpdateData = auditUpdateData;
      }
      if (auditReason) {
        // 审核不通过原因
        submitParam.auditReason = auditReason;
      }
      // const params = {
      //   nodeId,
      //   auditStatus,
      //   auditReason,
      // };

      const res = (await this.http.post(
        '/audit_service/task/audit',
        submitParam,
        // { params },
      )) as string;

      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }


  /** 主营业务代码列表 */
  async mainBusinessAtagList(params?: any) {
    try {
      const res = (await this.http.get('main-business/atag/list', { params })) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }
  /** 主营业务代码规则 */
  async mainBusinessAtagRule(params?: any) {
    try {
      const res = (await this.http.get('main-business/atagRule', { params })) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }


  async checkAddressDifference(params?: any) {
    try {
      const result: any = await this.http.post('main-business/check/address/difference', params);
      return result;
    } catch (error) {
      return null;
    }
  }
}
